<template>
  <div class="dashboard">
    <!-- Cabeçalho da Página -->
    <div class="d-flex justify-content-between align-items-end mb-4 flex-wrap gap-3">
      <div>
        <h2 class="fw-bold mb-1 text-dark" style="font-size: 1.5rem;">Análise de Desempenho</h2>
        <p class="text-secondary mb-0" style="font-size: 0.9rem;">Métricas e indicadores para o período atual</p>
      </div>
      <div>
        <button class="btn btn-pmg-light shadow-sm d-flex align-items-center" data-bs-toggle="modal"
          data-bs-target="#filtroPeriodoModal">
          <i class="bi bi-calendar3 me-2"></i>
          {{ formatDisplayDate(filtro.dataInicial) }} - {{ formatDisplayDate(filtro.dataFinal) }}
        </button>
      </div>
    </div>

    <!-- Grid de Indicadores (Integrado à API) -->
    <div class="row g-4 mb-4">

      <!-- Card 1: Total Arrecadado (Dividido em Recebido vs Pendente) -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card p-4 h-100 justify-content-between">

          <!-- Cabeçalho do Card -->
          <div class="d-flex align-items-center text-secondary mb-2">
            <div
              class="rounded-2 p-2 bg-success bg-opacity-10 text-success me-2 d-flex align-items-center justify-content-center"
              style="width: 32px; height: 32px;">
              <i class="bi bi-cash-stack fs-6"></i>
            </div>
            <span class="fw-medium" style="font-size: 0.9rem;">Total Arrecadado</span>
          </div>

          <!-- Conteúdo em 2 Colunas -->
          <div class="row g-0 align-items-center my-2">
            <!-- Coluna 1: Recebido (Verde) -->
            <div class="col-6 border-end pe-2">
              <small class="text-muted d-block fw-medium mb-1" style="font-size: 0.75rem;">
                <i class="bi bi-check-circle-fill text-success me-1"></i> Recebido
              </small>
              <h4 class="fw-bold text-success mb-0" style="font-size: 1.2rem;">
                R$ {{ formatCurrency(cards.total_amount_raised) }}
              </h4>
            </div>

            <!-- Coluna 2: Pendente (Amarelo/Laranja) -->
            <div class="col-6 ps-3">
              <small class="text-muted d-block fw-medium mb-1" style="font-size: 0.75rem;">
                <i class="bi bi-clock-history text-warning me-1"></i> Pendente
              </small>
              <h4 class="fw-bold text-warning mb-0" style="font-size: 1.2rem;">
                R$ {{ formatCurrency(cards.total_pending_amount) }}
              </h4>
            </div>
          </div>

          <!-- Rodapé -->
          <small class="text-muted fw-normal" style="font-size: 0.75rem;">
            <i class="bi bi-arrow-up-right me-1"></i> Indicadores do período
          </small>

        </div>
      </div>

      <!-- Card 2: Disponível p/ Saque -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card p-4 h-100">
          <div class="d-flex align-items-center mb-3 text-secondary">
            <div
              class="rounded-2 p-2 bg-warning bg-opacity-10 text-warning me-2 d-flex align-items-center justify-content-center"
              style="width: 32px; height: 32px;">
              <i class="bi bi-wallet2 fs-6"></i>
            </div>
            <span class="fw-medium" style="font-size: 0.9rem;">Disponível p/ Saque</span>
          </div>
          <h3 class="fw-bold mb-2 text-dark" style="font-size: 1.75rem;">
            R$ {{ formatCurrency(cards.available_withdraw) }}
          </h3>
          <small class="text-secondary fw-medium" style="font-size: 0.8rem;">
            <i class="bi bi-clock"></i> Aguardando solicitação
          </small>
        </div>
      </div>

      <!-- Card 3: Apoiadores Únicos -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card p-4 h-100">
          <div class="d-flex align-items-center mb-3 text-secondary">
            <div
              class="rounded-2 p-2 bg-primary bg-opacity-10 text-primary me-2 d-flex align-items-center justify-content-center"
              style="width: 32px; height: 32px;">
              <i class="bi bi-people fs-6"></i>
            </div>
            <span class="fw-medium" style="font-size: 0.9rem;">Apoiadores Únicos</span>
          </div>
          <h3 class="fw-bold mb-2 text-primary" style="font-size: 1.75rem;">
            {{ cards.unique_supporters }}
          </h3>
          <small class="text-primary fw-medium" style="font-size: 0.8rem;">
            <i class="bi bi-person-check"></i> Doadores distintos
          </small>
        </div>
      </div>



      <!-- Card 4: Total Já Repassado -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card p-4 h-100">
          <div class="d-flex align-items-center mb-3 text-secondary">
            <div
              class="rounded-2 p-2 bg-info bg-opacity-10 text-info me-2 d-flex align-items-center justify-content-center"
              style="width: 32px; height: 32px;">
              <i class="bi bi-shield-check fs-6"></i>
            </div>
            <span class="fw-medium" style="font-size: 0.9rem;">Total Já Repassado</span>
          </div>
          <h3 class="fw-bold mb-2 text-info" style="font-size: 1.75rem;">
            R$ {{ formatCurrency(cards.total_transferred) }}
          </h3>
          <small class="text-secondary fw-medium" style="font-size: 0.8rem;">
            <i class="bi bi-check-all"></i> Transferido com sucesso
          </small>
        </div>
      </div>

    </div>

    <!-- Seção Inferior: Gráfico e Transações -->
    <div class="row g-4">
      <!-- Gráfico de Evolução das Doações -->
      <div class="col-12 col-xl-8">
        <div class="card p-4 h-100" style="min-height: 400px;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 class="fw-bold mb-0">Evolução das Doações</h5>
              <small class="text-secondary">Volume de captação diária no período</small>
            </div>
            <!-- Botão Recarregar Dados -->
            <button class="btn btn-pmg-light btn-sm d-flex align-items-center" @click="fetchDashboardData"
              :disabled="isLoading">
              <i class="bi bi-arrow-clockwise me-1"
                :class="{ 'spinner-border spinner-border-sm border-0': isLoading }"></i> Atualizar
            </button>
          </div>

          <!-- Renderização do Gráfico Moderno -->
          <div class="flex-grow-1 mt-3" style="min-height: 280px; position: relative;">
            <LineChart v-if="chartData.datasets.length && !isLoading" :chart-data="chartData" />
            <!-- Loading do gráfico -->
            <div v-if="isLoading" class="position-absolute top-50 start-50 translate-middle text-secondary">
              <div class="spinner-border" role="status"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Últimos Apoios -->
      <div class="col-12 col-xl-4">
        <div class="card p-4 h-100 d-flex flex-column">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="fw-bold mb-0 fs-6"><i class="bi bi-heart-fill text-danger me-2"></i> Últimos Apoios</h5>
          </div>

          <div v-if="recentDonations.length > 0" class="d-flex flex-column gap-3 mb-4">
            <div v-for="donation in recentDonations" :key="donation.id"
              class="d-flex justify-content-between align-items-center border-bottom pb-2">
              <div>
                <h6 class="fw-bold mb-0 text-dark" style="font-size: 0.9rem;">{{ donation.name }}</h6>
                <small class="text-muted" style="font-size: 0.75rem;">{{ donation.campaign }}</small>
              </div>
              <span class="fw-bold text-success">+ R$ {{ formatCurrency(donation.amount) }}</span>
            </div>
          </div>

          <div v-else class="text-center py-4 text-muted small">
            Nenhuma doação registrada neste período.
          </div>

          <div class="mt-auto">
            <button class="btn btn-pmg-light w-100" disabled>Ver todas</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Filtro de Período -->
    <div class="modal fade" id="filtroPeriodoModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow" style="border-radius: 16px;">
          <div class="modal-header border-0 pb-0 pt-4 px-4 d-flex justify-content-between align-items-center">
            <h5 class="modal-title fw-bold d-flex align-items-center text-dark">
              <i class="bi bi-calendar-event text-brand me-2"></i> Filtrar Período
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body px-4 pt-3 pb-4">
            <p class="text-secondary small mb-4">
              Selecione o intervalo de datas para atualizar os indicadores do painel.
            </p>

            <div class="row g-3">
              <div class="col-6">
                <label class="form-label fw-bold text-secondary small mb-2">Data Inicial</label>
                <input type="date" class="form-control text-secondary border-light-subtle shadow-sm px-3 py-2"
                  v-model="filtro.dataInicial" style="border-radius: 8px;">
              </div>
              <div class="col-6">
                <label class="form-label fw-bold text-secondary small mb-2">Data Final</label>
                <input type="date" class="form-control text-secondary border-light-subtle shadow-sm px-3 py-2"
                  v-model="filtro.dataFinal" style="border-radius: 8px;">
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 px-4 pb-4 pt-0 gap-2">
            <button type="button" class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-pmg-primary px-4" data-bs-dismiss="modal"
              @click="aplicarFiltro">Aplicar Filtro</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import LineChart from '@/components/LineChart.vue'
import api from '@/services/api' // Ajuste o caminho conforme o seu projeto RMR Sistemas

export default {
  name: 'DashboardView',
  components: {
    LineChart
  },
  data() {
    return {
      isLoading: false,
      filtro: {
        // Inicializa com o mês atual por padrão
        dataInicial: '2026-08-01',
        dataFinal: '2026-08-31'
      },
      cards: {
        total_amount_raised: 0,
        total_pending_amount: 0,
        unique_supporters: 0,
        available_withdraw: 0,
        total_transferred: 0
      },
      recentDonations: [],
      chartData: {
        labels: [],
        datasets: []
      }
    }
  },
  mounted() {
    // Carrega os dados reais assim que a tela abre
    this.fetchDashboardData()
  },
  methods: {
    async fetchDashboardData() {
      this.isLoading = true;
      try {
        const response = await api.get('/client-jwt/landing-pages/dashboard', {
          params: {
            start_date: this.filtro.dataInicial,
            end_date: this.filtro.dataFinal
          }
        });

        const metrics = response.data.data;

        // Alimenta as variáveis do Front-end
        this.cards = metrics.cards;
        this.recentDonations = metrics.recent_donations;

        // Atualiza o Gráfico com as datas e valores reais da API
        this.chartData = {
          labels: metrics.chart.labels,
          datasets: [
            {
              label: 'Doações (R$)',
              borderColor: '#561569',
              borderWidth: 3,
              backgroundColor: (ctx) => {
                const canvas = ctx.chart.ctx
                const gradient = canvas.createLinearGradient(0, 0, 0, 300)
                gradient.addColorStop(0, 'rgba(86, 21, 105, 0.25)')
                gradient.addColorStop(1, 'rgba(86, 21, 105, 0.0)')
                return gradient
              },
              fill: true,
              data: metrics.chart.data
            }
          ]
        };
      } catch (error) {
        console.error("Erro ao carregar os dados do dashboard", error);

        // Verifica se você usa Notification ou showAlert
        if (this.$notify) {
          this.$notify({
            type: 'error',
            title: 'Erro de Conexão',
            text: 'Não foi possível buscar as métricas do servidor.'
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    aplicarFiltro() {
      this.fetchDashboardData();

      if (this.$notify) {
        this.$notify({
          type: 'success',
          title: 'Filtro Aplicado',
          text: 'Os indicadores foram atualizados para o novo período.'
        });
      }
    },

    // Funções Auxiliares de Formatação
    formatCurrency(value) {
      if (value === undefined || value === null) return '0,00';
      return parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }, 

    formatDisplayDate(dateString) {
      if (!dateString) return '';
      const [year, month, day] = dateString.split('-');
      const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      return `${day} ${months[parseInt(month) - 1]} ${year}`;
    }
  }
}
</script>